import React from "react";
import { MiModalConfirm } from "@miview/components";
import { useTheme } from "@mui/material";
import { propertySectionCategoryService } from "@miview/api";
import { HTTP_STATUSES } from "@miview/constants";

const AreaCategoryDeleteModal = (props) => {
  const { open, onClose, selection } = props;

  const theme = useTheme();

  const handleDelete = async () => {
    const response = await propertySectionCategoryService.delete({
      id: selection.id,
    });
    if (response.status === HTTP_STATUSES.OK) {
      onClose();
    }
  };

  return (
    <MiModalConfirm
      titleColor={theme.palette.primary.red}
      title={"Confirm Delete"}
      open={open}
      description={`Delete the following Area Category: ${selection.name}?`}
      handlePositive={handleDelete}
      handleNegative={onClose}
    ></MiModalConfirm>
  );
};

export default AreaCategoryDeleteModal;

